/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBriqueCommand
 */
export interface CreateBriqueCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBriqueCommand
     */
    nom: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBriqueCommand
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBriqueCommand
     */
    nomBase: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBriqueCommand
     */
    portails: Array<string>;
}

/**
 * Check if a given object implements the CreateBriqueCommand interface.
 */
export function instanceOfCreateBriqueCommand(value: object): value is CreateBriqueCommand {
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('nomBase' in value) || value['nomBase'] === undefined) return false;
    if (!('portails' in value) || value['portails'] === undefined) return false;
    return true;
}

export function CreateBriqueCommandFromJSON(json: any): CreateBriqueCommand {
    return CreateBriqueCommandFromJSONTyped(json, false);
}

export function CreateBriqueCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBriqueCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'],
        'description': json['description'] == null ? undefined : json['description'],
        'nomBase': json['nomBase'],
        'portails': json['portails'],
    };
}

export function CreateBriqueCommandToJSON(json: any): CreateBriqueCommand {
    return CreateBriqueCommandToJSONTyped(json, false);
}

export function CreateBriqueCommandToJSONTyped(value?: CreateBriqueCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'description': value['description'],
        'nomBase': value['nomBase'],
        'portails': value['portails'],
    };
}

